import React from 'react';
import { Phone } from 'lucide-react';

const NewHero = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center pt-16"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1523413651479-597eb2da0ad6?w=1920&q=75&auto=format&fit=crop')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-12">
        <div className="max-w-4xl mx-auto animate-fade-in">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight px-2">
            Expert Tiling Services You Can Trust
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-200 mb-8 sm:mb-10 leading-relaxed px-4">
            Specialising in high-quality floor, wall, bathroom, and kitchen tiling across Brisbane and surrounding areas.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
            <a href="#contact" className="w-full sm:w-auto">
              <button className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 sm:px-8 py-4 sm:py-6 text-base sm:text-lg rounded-lg transition-all duration-300 transform hover:scale-105 shadow-xl">
                Get a Quote
              </button>
            </a>
            <a href="tel:+61434344277" className="w-full sm:w-auto">
              <button className="w-full bg-white hover:bg-gray-100 text-gray-900 px-6 sm:px-8 py-4 sm:py-6 text-base sm:text-lg rounded-lg transition-all duration-300 transform hover:scale-105 shadow-xl flex items-center justify-center gap-2">
                <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
                Call Now
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewHero;